import { ICreateClaimRequest } from "common/interfaces/apiRequest/ICreateClaimRequest";
import { IInvoiceSearchRequest } from "common/interfaces/apiRequest/IInvoiceSearchRequest";
import { ICustomer } from "common/interfaces/ICustomer";
import { IInvoice } from "common/interfaces/IInvoice";
import { IUser } from "common/interfaces/IUser";
import { IWorkflow } from "common/interfaces/IWorkflow";
import { ClaimApi } from "core/api/ClaimApi";
import { UserApi } from "core/api/UserApi";
import { WorkflowApi } from "core/api/WorkflowApi";
import { action, makeAutoObservable, observable, runInAction } from "mobx";
import { IClaim } from "common/interfaces/IClaim";
import { IInvoiceLineItemsSearchRequest } from "common/interfaces/apiRequest/IInvoiceLineItemsSearchRequest";
import { IClaimLineItem } from "common/interfaces/IClaimLineItem";
import { UserStore } from "./UserStore";

export class ClaimStore {
    @observable public customers: ICustomer[] = [];
    @observable public invoices: IInvoice[] = [];
    @observable public claims: IClaim[] = [];
    @observable public selectedInvoice: IInvoice | undefined = undefined;
    @observable public selectedClaimTypeLabel: string | undefined = undefined;
    @observable public selectedClaimTypeValue: number| undefined = undefined;

    private userStore: UserStore;

    constructor(userStore: UserStore) {
        this.userStore = userStore;
        makeAutoObservable(this);
    }

    @action
    public async getCustomers(): Promise<any> {
        let customers: ICustomer[] = [];
        return ClaimApi.getCutomers().then((response) => {
            customers = response.customers;
            this.customers = customers;
            return customers;
        });
    }

    @action
    public async getClaims(): Promise<any> {
        let claims: IClaim[] = [];
        return ClaimApi.getClaims().then((response) => {
            claims = response.claims;
            this.claims = claims;
            return claims;
        });
    }

    @action
    public async getPaginatedClaims(page: number, pageSize: number, searchText: string, customer: string, status: number, claimFilter: number): Promise<any> {        
        return ClaimApi.getPaginatedClaims(page,pageSize,searchText,customer, status, claimFilter);
    }

    public isCurrentUserActioner(claim: IClaim) : boolean  {
        this.userStore.setCurrentUser();
        var retrunVal = this.userStore.currentUser?.userId === claim.actionerUserId;        
        return retrunVal;
    }

    @action
    public async getOutstandingClaims(): Promise<any> {
        return ClaimApi.getOutstandingClaims();        
    }

    @action
    public async getClaimAudit(claimId: number): Promise<any> {        
        return ClaimApi.getClaimAuditById(claimId);
    }

    @action
    public async getClaimWorkflow(claimId: number): Promise<any> {        
        return ClaimApi.getClaimWorkflow(claimId);
    }

    @action
    public async searchInvoice(invoiceSearchRequest: IInvoiceSearchRequest): Promise<any> {
        let invoices: IInvoice[] = [];
        return ClaimApi.searchInvoice(invoiceSearchRequest).then((response) => {
            invoices = response.invoices;
            this.invoices = invoices;
            return invoices;
        });
    }

    @action
    public async createClaim(createClaimRequest: ICreateClaimRequest): Promise<any> {        
        return ClaimApi.createClaim(createClaimRequest);
    }

    @action
    public async saveClaimProducts(products: IClaimLineItem[]): Promise<any> {        
        return ClaimApi.saveClaimProducts(products);
    }

    @action
    public async getClaimById(claimId: number): Promise<any> {        
        return ClaimApi.getClaimById(claimId);
    }

    @action
    public async submitClaim(claimId: number, products: IClaimLineItem[]): Promise<any> {        
        return ClaimApi.submitClaim(claimId,products);
    }

    public async getClaimCreditReasonCodes(): Promise<any> {
        return ClaimApi.getClaimCreditReasonCodes();
    }

    public async updateClaimStatusWithComment(updateRequest: any): Promise<any> {       
        return ClaimApi.updateClaimStatusWithComment(updateRequest);
    }

    public async getAttachementsByClaimId(claimId: number): Promise<any> {       
        return ClaimApi.getAttachementsByClaimId(claimId);
    }

    public async getAttachementByClaimAttachmentId(claimAttachmentId: number): Promise<any> {       
        return ClaimApi.getAttachementByClaimAttachmentId(claimAttachmentId);
    }

    public async removeAttachementByClaimAttachmentId(claimAttachmentId: number): Promise<any> {       
        return ClaimApi.removeAttachementByClaimAttachmentId(claimAttachmentId);
    }

    public async saveComment(claimId: number,notifyUsers: IUser[], comment: string): Promise<any> {       
        return ClaimApi.saveComment(claimId,notifyUsers,comment);
    }

    public async getCommentsByClaimId(claimId: number): Promise<any> {       
        return ClaimApi.getCommentsByClaimId(claimId);
    }

    @action
    public async updateClaimAccountManager(claimId: number, accountManagerId: number, debitNoteNumber : string): Promise<any> {        
        return ClaimApi.updateClaimAccountManager(claimId, accountManagerId,debitNoteNumber);
    }



    @action
    public async getInvoiceLintemsBySalesOrder(invoiceLineItemsSearchRequest: IInvoiceLineItemsSearchRequest): Promise<any> {        
        return ClaimApi.searchInvoiceItems(invoiceLineItemsSearchRequest);
    }

    @action
    public async setSelectedClaimAndType(selectedInvoice: IInvoice, selectedClaimTypeLabel: string, selectedClaimTypeValue: number) {
        runInAction(() => {
            this.selectedInvoice = selectedInvoice;
            this.selectedClaimTypeLabel = selectedClaimTypeLabel;
            this.selectedClaimTypeValue = selectedClaimTypeValue
        });
    }

    @action
    public async clearSelectedClaimAndType() {
        runInAction(() => {
            this.selectedInvoice = undefined;
            this.selectedClaimTypeLabel = undefined;
            this.selectedClaimTypeValue = undefined;
        });
    }
}
